import script from "./FirestormArena.vue?vue&type=script&setup=true&lang=js"
export * from "./FirestormArena.vue?vue&type=script&setup=true&lang=js"

import "./FirestormArena.vue?vue&type=style&index=0&id=7c2dc55d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c2dc55d"]])

export default __exports__